module.exports = __webpack_public_path__ + "img/pantalla6-3.7cbc6ce6.png";